import { Routes } from '@angular/router';

export const routes: Routes = [
  { path: '', redirectTo: '/home', pathMatch: 'full' },
  { path: 'home', loadComponent: () => import('./components/home/home.component').then(m => m.HomeComponent) },
  { path: 'import-data', loadComponent: () => import('./components/import-data/import-data.component').then(m => m.ImportDataComponent) },
  { path: 'report', loadComponent: () => import('./components/report/report.component').then(m => m.ReportComponent) },
  { path: 'clients', loadComponent: () => import('./components/clients/clients.component').then(m => m.ClientsComponent) },
  { path: 'client/:id', loadComponent: () => import('./components/report-client/report-client.component').then(m => m.ReportClientComponent) },
  { path: 'whatsapp', loadComponent: () => import('./components/whatsapp/whatsapp.component').then(m => m.WhatsappComponent) },
  { path: 'settings', loadComponent: () => import('./components/settings/settings.component').then(m => m.SettingsComponent) },
  { path: 'messages-sent', loadComponent: () => import('./components/messages-sent/messages-sent.component').then(m => m.MessagesSentComponent) },
  { path: 'login', loadComponent: () => import('./components/login/login.component').then(m => m.LoginComponent) },
  { path: 'reset-password', loadComponent: () => import('./components/login/login.component').then(m => m.LoginComponent) },

  { path: '**', redirectTo: 'home', pathMatch: 'full' }
];
